import type { PlannerSubmit } from '@voll-intelligence/intelligence-ui-kit/flight-planner';
import type { GenUiSearchWait } from '../../../shared/ui/action.js';
import { fmtDayMonth, fmtTripRange } from '../../../shared/ui/flight_format.js';
import { searchWaitProfile, searchWaitRoute } from '../../../shared/ui/search_wait.js';

/**
 * The wait context of a flight search (#5889): the route in cities (the echo carries
 * IATA codes only), the dates as the card shows them, and the trip form, which decides
 * whether the host's plan searches returns. A code with no city keeps the code.
 */
export function flightSearchWait(
  request: PlannerSubmit,
  context: Readonly<{
    cityOf: (iata: string) => string | null | undefined;
    requesterId: string | undefined;
    locale: string;
  }>,
): GenUiSearchWait {
  const { cityOf, requesterId, locale } = context;
  const city = (iata: string) => cityOf(iata) ?? iata;
  const profile = searchWaitProfile(request.travelers, requesterId);
  if (request.action === 'search_multi') {
    const first = request.legs[0];
    const last = request.legs.at(-1);
    if (!first || !last) return { profile, trip: 'multi_leg' };
    return {
      profile,
      trip: 'multi_leg',
      route: searchWaitRoute(city(first.origin), city(last.destination)),
      dates: fmtTripRange(first.date, last.date, locale) || undefined,
    };
  }
  const { origin, destination, outboundDate, returnDate } = request;
  return {
    profile,
    trip: returnDate ? 'round_trip' : 'one_way',
    route: searchWaitRoute(city(origin), city(destination)),
    dates: fmtTripRange(outboundDate, returnDate, locale) || undefined,
    returnDate: returnDate ? fmtDayMonth(returnDate, locale) || undefined : undefined,
  };
}
